import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../views/login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/homePage.vue'),
    meta: {
      title: '快巴士—发布需求·司机抢单'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      title: '快巴士—发布需求·司机抢单'
    }
  },
  {
    path: '/applyFor',
    name: 'applyFor',
    component: () => import('../views/applyFor.vue'),
    meta: {
      title: '快巴士—发布需求·司机抢单'
    }
  },
  {
    path: '/personal',
    name: 'personal',
    component: () => import('../views/ApplyFor/personal.vue')
  },
  {
    path: '/personalRecord',
    name: 'personalRecord',
    component: () => import('../views/ApplyFor/personalRecord.vue')
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import('../views/process/payment.vue')
  },
  {
    path: '/accomplish',
    name: 'accomplish',
    component: () => import('../views/process/accomplish.vue')
  },
  {
    path: '/share',
    name: 'share',
    component: () => import('../views/share.vue'),

  },

  {
    path: '/datum',
    name: 'datum',
    component: () => import('../views/MemberCenter/datum.vue'),
    meta: {
      title: '快巴士—发布需求·司机抢单'
    }
  },
  {
    path: '/falls',
    name: 'falls',
    component: () => import('../components/Falls.vue')
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/search.vue'),
    meta: {
      title: '快巴士—发布需求·司机抢单'
    }
  }, {
    path: '/details',
    name: 'details',
    component: () => import('../views/details.vue'),
    meta: {
      title: '快巴士—发布需求·司机抢单'
    }
  }, {
    path: '/video',
    name: 'video',
    component: () => import('../views/videoView.vue')
  }, {
    path: '/modify',
    name: 'modify',
    component: () => import('../views/apply_modify.vue')
  }, {
    path: '/exhibition',
    name: 'exhibition',
    component: () => import('../views/exhibition.vue'),
    meta: {
      title: '快巴士—发布需求·司机抢单'
    }
  }, {
    path: '/distali',
    name: 'distali',
    component: () => import('../views/distali.vue'),
    meta: {
      title: '快巴士—发布需求·司机抢单'
    }
  }
]

const router = new VueRouter({
  mode: 'hash',//history
  base: process.env.BASE_URL,
  routes
})

export default router
